import OnlineUsage from './component';
import _routes from './routes';

export const routes = _routes;

export default OnlineUsage;



// WEBPACK FOOTER //
// ./containers/Group/Homework/OnlineUsage/index.js